/**
 * 머리글 도구줄 토글 `[도구 ▾]` — 좁은 화면에서만 선다(lib/use-header-tools.ts).
 *
 * 접근성: `aria-expanded` 로 상태를 말하고 `aria-controls` 로 도구줄을 가리킨다.
 * 키보드 포커스 표시는 DS Button 의 `focus-visible:ring` 이 담당한다(별도
 * 스타일을 겹치지 않는다 — 두 링이 겹치면 오히려 안 보인다).
 */

import { Button } from '@cupia/ui/button'
import { ChevronDown } from 'lucide-react'

export function HeaderToolsToggle({
  expanded,
  onToggle,
  controls,
  className = '',
}: {
  expanded: boolean
  onToggle: () => void
  /** 도구줄 컨테이너의 id(`aria-controls`) */
  controls: string
  className?: string
}): React.ReactElement {
  return (
    <Button
      variant={expanded ? 'secondary' : 'ghost'}
      size="sm"
      className={className}
      onClick={onToggle}
      aria-expanded={expanded}
      aria-controls={controls}
      data-testid="header-tools-toggle"
      title={expanded ? '도구줄을 접습니다' : '도구줄을 펼칩니다'}
    >
      도구
      <ChevronDown
        aria-hidden
        className={`h-4 w-4 transition-transform ${expanded ? 'rotate-180' : ''}`}
      />
    </Button>
  )
}
